<template>
    <div class="OnlineTeacher">

        <div class="container-fluid grey-bg-line centers-list">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumbs">
                            <a href="/">Главная</a> / ONLINETeacher
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-3 hometeacher-duck">
                        <div class="tv-bird"></div>
                    </div>
                    <div class="col-12 col-sm-3 onlineteacher-choose mobile-vers" style="text-align: center;">
                        <router-link to="/onlineteacher"><img src="@/assets/hometeacher/images/onlineteacher-logo.png" style="max-width: 100%; margin-top: 20px;">
                        </router-link>
                        <div class="choose-course" style="margin-bottom: 35px;">
                            <select name="lang" v-model="langFilter">
                                <option :value="null">{{ $t('select_language') }}</option>
                                <option value="lang/en">{{ $t('english_lang') }}</option>
                                <option value="lang/es">{{ $t('spanish_lang') }}</option>
                                <option value="lang/de">{{ $t('german_lang') }}</option>
                                <option value="lang/fr">{{ $t('french_lang') }}</option>
                                <option value="lang/ch">{{ $t('chinese_lang') }}</option>
                                <option value="lang/ru">{{ $t('russian_lang') }}</option>
                            </select>
                        </div>

                        <div class="choose-age" style="margin-bottom: 35px;">
                            <select name="age" v-model="ageFilter">
                                <option :value="null">{{ $t('Age') }}</option>
                                <option value="min/1/max/6">{{ $t('preschooler') }}</option>
                                <option value="min/7/max/11">{{ $t('schoolboy_1_4_class') }}</option>
                                <option value="min/12/max/99">{{ $t('parent') }}</option>
                                <!-- <option value="min/12/max/17">12-17 лет</option> -->
                            </select>
                        </div>

                        <div class="ind-grup">
                            <div class="form_toggle">
                                <div class="form_toggle-item item-1">
                                    <input id="fid-1" type="radio" name="radio" value="off" :checked="buttonName === 'Показать расписание'"
                                           @click="buttonName = 'Показать расписание'">
                                    <label for="fid-1">Групповое</label>
                                </div>
                                <div class="form_toggle-item item-2">
                                    <input id="fid-2" type="radio" name="radio" value="on" :checked="buttonName === $t('sign_up')"
                                           @click="buttonName = $t('sign_up')">
                                    <label for="fid-2">Индивидуальное</label>
                                </div>
                            </div>
                        </div>

                        <div class="knopka">
                            <input id="showTimetable" type="button" class="bluesubmit" v-model="buttonName"
                                   @click="submitIf">
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 hometeacher-logo">
                        <router-link to="/onlineteacher"><img src="@/assets/hometeacher/images/onlineteacher-logo.png" class="desktop-vers">
                        </router-link>
                        <p class="px18">
                            <span class="strong-black">Полное ощущение присутствия, любимые преподаватели и разнообразные программы &ndash;</span><br>
                          всё это формат OnlineTeacher от языковых центров Полиглотики! Он максимально приближен к очному обучению и предполагает занятия онлайн с педагогом в группах или индивидуально. Подходит для детей от 1 года до 12 лет.<br>
                            <span class="strong-red">Пробное занятие бесплатно!</span>
                        </p>
                    </div>
                    <div class="col-12 col-sm-3 onlineteacher-choose desktop-vers">
                        <div class="choose-course" style="margin-bottom: 35px;">
                            <select name="lang" v-model="langFilter">
                                <option :value="null">{{ $t('select_language') }}</option>
                                <option value="lang/en">{{ $t('english_lang') }}</option>
                                <option value="lang/es">{{ $t('spanish_lang') }}</option>
                                <option value="lang/de">{{ $t('german_lang') }}</option>
                                <option value="lang/fr">{{ $t('french_lang') }}</option>
                                <option value="lang/ch">{{ $t('chinese_lang') }}</option>
                                <option value="lang/ru">{{ $t('russian_lang') }}</option>
                            </select>
                        </div>

                        <div class="choose-age" style="margin-bottom: 35px;">
                            <select name="age" v-model="ageFilter">
                                <option :value="null">{{ $t('Age') }}</option>
                                <option value="min/1/max/6">{{ $t('preschooler') }}</option>
                                <option value="min/7/max/11">{{ $t('schoolboy_1_4_class') }}</option>
                                <option value="min/12/max/99">{{ $t('parent') }}</option>
                                <!--<option value="min/12/max/17">12-17 лет</option>-->
                            </select>
                        </div>

                        <div class="ind-grup">
                            <div class="form_toggle">
                                <div class="form_toggle-item item-1">
                                    <input id="fid1-1" type="radio" name="radio1" value="off" :checked="buttonName === 'Показать расписание'"
                                           @click="buttonName = 'Показать расписание'">
                                    <label for="fid-1">Групповое</label>
                                </div>
                                <div class="form_toggle-item item-2">
                                    <input id="fid1-2" type="radio" name="radio1" value="on" :checked="buttonName === $t('sign_up')"
                                           @click="buttonName = $t('sign_up')">
                                    <label for="fid1-2">Индивидуальное</label>
                                </div>
                            </div>
                        </div>

                        <div class="knopka">
                            <input id="showTimetable1" type="button" class="bluesubmit" v-model="buttonName"
                                   @click="submitIf">
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="container-fluid grey-kapla-bg"></div>


        <div class="container-fluid white-bg fr-page no-shadow">
            <div class="container align-middle">

                <div class="row dla-kogo">
                    <div class="col-12 col-sm-3 group4birds" >
                        <img class="dla-kogo-img" src="@/assets/poliglotiki/images/bird-1.png">
                        <h4>Для кого?</h4>
                        <p>Для усидчивых детей в возрасте от 1 до 12 лет.</p>
                        <div class="leftpunktir"></div>
                    </div>

                    <div class="col-12 col-sm-3">
                        <img class="chto-uchim-img" src="@/assets/poliglotiki/images/bird-2.png">
                        <h4>Что учим?</h4>
                        <p style="padding-right: 10px;">6 языков и более 80 программ на выбор.</p>
                        <div class="leftpunktir"></div>
                    </div>

                    <div class="col-12 col-sm-3">
                        <img class="kak-img" src="@/assets/poliglotiki/images/bird-3.png">
                        <h4 class="dla-kogo-kak">Как?</h4>
                        <p>Индивидуально или в группе.</p>
                        <div class="leftpunktir"></div>
                    </div>

                    <div class="col-12 col-sm-3">
                        <img class="kogda-img" src="@/assets/poliglotiki/images/bird-4.png">
                        <h4 class="dla-kogo-kogda">Когда?</h4>
                        <p>По удобному расписанию.</p>
                    </div>
                </div>

                <!--
                <div class="row" v-if="error">
                    <div class="col-12">
                        <base-alert type="danger">{{error}}</base-alert>
                    </div>
                </div>

                <div class="row" v-if="entryCreated">
                    <div class="col-12">
                        <base-alert type="success" dismissible>
                            Заявка успешно отправлена! Мы свяжемся с Вами при первой возможности.
                        </base-alert>
                    </div>
                </div>

                <div class="row" v-else>
                    <div class="col-12 col-sm-3">
                        <base-input v-model="name"
                                    :error="fieldError('name')"
                                    size="30" maxlength="255" placeholder="Ваше имя*" class="entry2"
                                    type="text" required/>
                    </div>

                    <div class="col-12 col-sm-3">
                        <base-input v-model="email"
                                    :error="fieldError('email')"
                                    size="30" maxlength="255" placeholder="E-mail*" class="entry2"
                                    type="text" required/>
                    </div>

                    <div class="col-12 col-sm-3">
                        <base-input v-model="phone"
                                    :error="fieldError('phone')"
                                    size="30" maxlength="255" placeholder="Телефон" class="entry2"
                                    type="text" required/>
                    </div>

                    <div class="col-12 col-sm-3" style="text-align:center;">
                        <input type="button" class="yellowsubmit" value="Записаться" @click="submit"
                               :disabled="loading">
                    </div>
                </div>
                -->
            <!--
                <div class="row">
                    <div class="col-12">
                        <p class="px18">Групповые или индивидуальные уроки от лучших профессиональных педагогов сети
                            языковых центров Полиглотики проходят в формате онлайн-конференций. Для того чтобы начать
                            занятия, необходимо выбрать программу. Детям доступно изучение английского, немецкого,
                            французского, испанского, итальянского, китайского и родного русского языка. Вариативны и
                            программы обучения: 70 направлений для разных возрастов и целей. Формат «OnlineTeacher»
                            также позволяет выбрать удобное расписание и преподавателя, с
                            которым ребенок будет учиться.</p>
                        <p class="px18">
                            <span class="strong-black">Внимание, акция! Бесплатно пробные занятия первые 3 дня!</span>
                        </p>
                    </div>
                </div>
            -->
            </div>
        </div>
        <div class="container-fluid blue-wave-top"></div>
        <div class="container-fluid grey-bg  fr-page no-shadow">
            <div class="container align-middle pdtop70px">

                <div class="row">
                    <div class="col-12 col-sm-7">
                        <h1 class="super-strong">Учите иностранные языки <span class="strong-green" style="font-size: 36px;">ONLINE!</span></h1>
                        <div class="row dla-kogo pdtop50px">
                            <div class="col-12 col-sm-4">
                                <img class="sun-img" src="@/assets/poliglotiki/images/sun.png">
                                <p>Утром или вечером</p>
                            </div>

                            <div class="col-12 col-sm-4">
                                <img class="calendar-img" src="@/assets/poliglotiki/images/calendar.png">
                                <p>2-3 дня в неделю</p>
                            </div>

                            <div class="col-12 col-sm-4">
                                <img class="twobirds-img" src="@/assets/poliglotiki/images/twobirds.png">
                                <p class="pdrght60px">12 месяцев в году</p>
                            </div>
                        </div>

                    </div>

                    <div class="col-sm-5">
                        <img class="mobile-noimg"
                             src="@/assets/hometeacher/images/girl-krug.png">
                    </div>
                </div>

                <div class="row pdtop50px">
                    <div class="col-12">
                        <p class="px18"><span class="strong-black">OnlineTeacher</span> &ndash; это групповые и индивидуальные занятия иностранными языками от профессиональных педагогов сети Полиглотики в режиме реального времени. Мы обучаем через Интернет, а значит, вы можете заниматься в любом удобном для вас месте.</p>

                        <p class="px18">Обучение детей по методике, основанной <span class="strong-black">на коммуникативном подходе</span>, предусматривает <span class="strong-black">полное погружение в изучаемую языковую среду</span>. Педагог говорит только на иностранном, что способствует <span class="strong-black">развитию билингвизма</span>. Ключевой элемент онлайн-обучения &ndash; <span class="strong-black">игра</span>, на ней построен наш образовательный процесс.
                        </p>
                    </div>
                </div>


            </div>
        </div>

        <div class="container-fluid green-feedback centers-list sshadow">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <img class="kapla-home lazyload" src="@/assets/hometeacher/images/kapla-grey.png">
                        <h2 class="yazik">Каким языкам обучаем?</h2>
                    </div>
                </div>

                <div class="row green-lng">
                    <div class="col-12 col-sm-4">
                        <div class="lng">
                             <img class="en-img" src="@/assets/hometeacher/images/i-en-green.png">
                             <p>Английский</p>
                        </div>
                        <div class="lng">
                            <img src="@/assets/hometeacher/images/i-fr-green.png">
                            <p>Французский</p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-4">
                        <div class="lng">
                            <img class="de-img" src="@/assets/hometeacher/images/i-de-green.png">
                            <p>Немецкий</p>
                         </div>
                        <div class="lng">
                            <img class="es-img" src="@/assets/hometeacher/images/i-es-green.png">
                            <p>Испанский</p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-4">
                        <div class="lng">
                            <img class="ch-img" src="@/assets/hometeacher/images/i-ch-green.png">
                            <p>Китайский</p>
                        </div>
                        <div class="lng">
                            <img class="ru-img" src="@/assets/hometeacher/images/i-ru-green.png">
                            <p>Русский</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid green-wave-bottom"></div>

        <div class="container-fluid white-bg no-shadow pdtop70px pdbottom100px">
            <div class="container align-middle">

                <div class="row">
                    <div class="col-12 about-center">
                        <h2 class="redh2">Преимущества «OnlineTeacher»: </h2>
                        <img class="preimushhestva desktop-vers" src="@/assets/hometeacher/images/preimushhestva.png"> <!-- десктопная версия -->
                        <img class="preimushhestva mobile-vers" src="@/assets/hometeacher/images/bird-comp.png">      <!-- мобильная версия -->
                        <div class="preimush mobile-vers">
                            <div class="punkt" style="min-height: 80px;">
                                <div class="greenkrug">1</div>
                                <div class="leftpunktir-yellow" style="height: 40px;"></div>
                                <img class="" src="@/assets/hometeacher/images/preimush-img-1.png" style="margin-top: 20px;">
                                <p>Интуитивная понятная платформа</p>

                            </div>
                            <div class="punkt">
                                <div class="greenkrug">2</div>
                                <div class="leftpunktir-yellow" style="height: 50px;"></div>
                                <p>Возможность индивидуальных и групповых занятий</p>
                            </div>
                            <div class="punkt">
                                <div class="greenkrug">3</div>
                                <div class="leftpunktir-yellow" style="height: 50px;"></div>
                                <img class="" src="@/assets/hometeacher/images/preimush-img-2.png" style="margin-top: -10px;">
                                <p>Выбор группы с учётом индивидуальных особенностей</p>
                            </div>
                            <div class="punkt" style="min-height: 65px;">
                                <div class="greenkrug">4</div>
                                <div class="leftpunktir-yellow" style="height: 40px;"></div>
                                <p style="padding-top: 10px;">Удобное расписание</p>
                            </div>
                            <div class="punkt" style="min-height: 80px;">
                                <div class="greenkrug">5</div>
                                <div class="leftpunktir-yellow" style="height: 40px;"></div>
                                <img class="" src="@/assets/hometeacher/images/preimush-img-3.png" style="margin-top: -10px;">
                                <p>Стабильный педагогический состав</p>
                            </div>
                            <div class="punkt">
                                <div class="greenkrug" style="margin-bottom: 30px;">6</div>
                                <div class="leftpunktir-yellow" style="height: 50px;"></div>
                                <p>Высокое качество работы преподавателей в формате онлайн</p>
                            </div>
                            <div class="punkt" style="min-height: 115px;">
                                <div class="greenkrug" style="margin-bottom: 50px;">7</div>
                                <div class="leftpunktir-yellow" style="height: 75px;"></div>
                                <img class="" src="@/assets/hometeacher/images/preimush-img-4.png">
                                <p>Возможность получения обратной связи и индивидуальных консультаций</p>
                            </div>
                            <div class="punkt" style="min-height: 75px;">
                                <div class="greenkrug">8</div>
                                <div class="leftpunktir-yellow" style="height: 40px;"></div>
                                <p>Постоянный контроль результатов</p>
                            </div>
                            <div class="punkt" style="min-height: 75px;">
                                <div class="greenkrug">9</div>
                                <div class="leftpunktir-yellow" style="height: 40px;"></div>
                                <img class="" src="@/assets/hometeacher/images/preimush-img-5.png" style="margin-top: -45px;">
                                <p>Использование методических материалов</p>
                            </div>
                            <div class="punkt" style="min-height: 75px;">
                                <div class="greenkrug">10</div>
                                <div class="leftpunktir-yellow" style="height: 40px;"></div>
                                <p>Увлекательный игровой процесс обучения</p>
                            </div>
                            <div class="punkt" style="min-height: 120px;">
                                <div class="greenkrug" style="margin-bottom: 50px;">11</div>
                                <div class="leftpunktir-yellow" style="height: 50px;"></div>
                                <img class="galka" src="@/assets/hometeacher/images/galka.png">
                                <img class="" src="@/assets/hometeacher/images/preimush-img-6.png" style="margin-top: -20px;">
                                <p>Более 80 программ и авторская методика</p>
                            </div>

                        </div>
                        <div class="knopka mobile-vers">
                            <input id="showTimetable2" type="button" class="bluesubmit wdth85" v-model="buttonName"
                                   @click="submitIf">
                        </div>
                        <img class="raketa mobile-vers" src="@/assets/hometeacher/images/raketa.png">
                        <!-- мобильная версия конец -->

                        <div class="knopka desktop-vers">
                            <input id="showTimetable2" type="button" class="bluesubmit" v-model="buttonName"
                                   @click="submitIf">
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="container-fluid blue-wave-top"></div>

        <div class="container-fluid blueback" id="feedback">
            <div class="container align-middle">
                <div class="row desktop-vers">                  <!-- десктопная версия -->
                    <div class="col-12 col-sm-6 onltcher">
                        <h2 class="blackh2">OnlineTeacher &ndash; это…</h2>
                        <p><span class="No">No</span><span class="number">1</span></p>
                        <h3>Образовательная онлайн-платформа</h3>
                        <p>Стабильная работа, бесперебойная связь, удобный личный кабинет, система оповещений, поддержка на всех этапах и консультации для родителей.</p>
                        <p><span class="strong-black">Мы всё продумали до мелочей</span>, чтобы вашему ребенку было <span class="strong-black">комфортно учиться и развиваться</span>.</p>
                        <br>

                        <p><span class="No">No</span><span class="number">3</span></p>
                        <h3>Современные учебные материалы</h3>
                        <p>Собственная методическая база «Полиглотиков» легла в основу онлайн-занятий для разных возрастов. Все материалы полностью адаптированы к онлайн-формату, имеют яркие иллюстрации, понятны и интересны детям. Материалы:</p>
                        <p><span class="strong-red">&bull;</span> обогащают словарный запас<br>
                            <span class="strong-red">&bull;</span> учат воспринимать язык визуально и на слух<br>
                            <span class="strong-red">&bull;</span> формируют устойчивую мотивацию к обучению
                        </p>
                        <br>

                        <p><span class="No">No</span><span class="number">5</span></p>
                        <h3>Возможность учиться в любом месте</h3>
                        <p>Не нужно тратить время на дорогу и сборы. Вы можете находиться в любом уголке мира, в любом городе и стране, и продолжать обучение. Утром или вечером, летом и зимой. <span class="strong-black">Режим занятий для ребенка родители выбирают сами</span>.</p>
                        <img class="speach" src="@/assets/hometeacher/images/speach.png">
                    </div>

                    <div class="col-12 col-sm-6 onltcher">
                        <img class="raketa" src="@/assets/hometeacher/images/raketa.png">
                        <p><span class="No">No</span><span class="number">2</span></p>
                        <h3>Профессиональные педагоги</h3>
                        <p><span class="strong-black">Высококвалифицированные педагоги</span> с высшим профильным образованием, с опытом работы в языковых центрах.</p>
                        <p>Преподаватели <span class="strong-black">проходят обучение и повышают свою квалификацию</span> в Санкт-Петербурге, Москве и дистанционно.</p>
                        <p>Проходят <span class="strong-black">строгий отбор</span>: только 1 из 50 кандидатов становится нашим педагогом.</p>

                        <p><span class="No">No</span><span class="number">4</span></p>
                        <h3>Уникальный формат обучения</h3>
                        <p>Педагоги работают по уникальной авторской методике «Полиглотиков».</p>
                        <p>Ее ключевая особенность &ndash; <span class="strong-black">полное погружение в язык</span>: любая деятельность происходит только на иностранном языке. Общение, пение, игры, разминки <span class="strong-black">без пояснений на русском</span>.</p>
                        <p>Только невербальное общение, мимика, жесты, наглядные материалы и иллюстрации позволяют понять и воспринять речь педагога.</p>

                        <p><span class="No">No</span><span class="number">6</span></p>
                        <h3>Тщательно составленное расписание</h3>
                        <p>Регулярность и системность особенно важны в изучении иностранных языков. Повторение и практика обеспечивают эффективность занятий и скорейшее достижение целей.</p>
                        <p><span class="strong-black">Рекомендуем заниматься минимум 2-3 раза в неделю, выполнять домашние задания и не пропускать уроки.</span>.</p>

                        <div class="knopka mrgtop110px">
                            <input id="showTimetable2" type="button" class="bluesubmit" v-model="buttonName"
                                   @click="submitIf">
                        </div>
                    </div>
                </div><!-- десктопная версия конец-->


                <div class="row mobile-vers">                  <!-- мобильная версия -->
                    <div class="col-12 onltcher">
                        <h2 class="blackh2">OnlineTeacher &ndash; это…</h2>
                        <p><span class="No">No</span><span class="number">1</span></p>
                        <h3>Образовательная онлайн-платформа</h3>
                        <p>Стабильная работа, бесперебойная связь, удобный личный кабинет, система оповещений, поддержка на всех этапах и консультации для родителей.</p>
                        <p><span class="strong-black">Мы всё продумали до мелочей</span>, чтобы вашему ребенку было <span class="strong-black">комфортно учиться и развиваться</span>.</p>
                        <br>

                        <p><span class="No">No</span><span class="number">2</span></p>
                        <h3>Профессиональные педагоги</h3>
                        <p><span class="strong-black">Высококвалифицированные педагоги</span> с высшим профильным образованием, с опытом работы в языковых центрах.</p>
                        <p>Преподаватели <span class="strong-black">проходят обучение и повышают свою квалификацию</span> в Санкт-Петербурге, Москве и дистанционно.</p>
                        <p>Проходят <span class="strong-black">строгий отбор</span>: только 1 из 50 кандидатов становится нашим педагогом.</p>
                        <br>

                        <p><span class="No">No</span><span class="number">3</span></p>
                        <h3>Современные учебные материалы</h3>
                        <p>Собственная методическая база «Полиглотиков» легла в основу онлайн-занятий для разных возрастов. Все материалы полностью адаптированы к онлайн-формату, имеют яркие иллюстрации, понятны и интересны детям. Материалы:</p>
                        <p><span class="strong-red">&bull;</span> обогащают словарный запас<br>
                            <span class="strong-red">&bull;</span> учат воспринимать язык визуально и на слух<br>
                            <span class="strong-red">&bull;</span> формируют устойчивую мотивацию к обучению
                        </p>

                        <p><span class="No">No</span><span class="number">4</span></p>
                        <h3>Уникальный формат обучения</h3>
                        <p>Педагоги работают по уникальной авторской методике «Полиглотиков».</p>
                        <p>Ее ключевая особенность &ndash; <span class="strong-black">полное погружение в язык</span>: любая деятельность происходит только на иностранном языке. Общение, пение, игры, разминки <span class="strong-black">без пояснений на русском</span>.</p>
                        <p>Только невербальное общение, мимика, жесты, наглядные материалы и иллюстрации позволяют понять и воспринять речь педагога.</p>

                        <p><span class="No">No</span><span class="number">5</span></p>
                        <h3>Возможность учиться в любом месте</h3>
                        <p>Не нужно тратить время на дорогу и сборы. Вы можете находиться в любом уголке мира, в любом городе и стране, и продолжать обучение. Утром или вечером, летом и зимой. <span class="strong-black">Режим занятий для ребенка родители выбирают сами</span>.</p>

                        <p><span class="No">No</span><span class="number">6</span></p>
                        <h3>Тщательно составленное расписание</h3>
                        <p>Регулярность и системность особенно важны в изучении иностранных языков. Повторение и практика обеспечивают эффективность занятий и скорейшее достижение целей.</p>
                        <p><span class="strong-black">Рекомендуем заниматься минимум 2-3 раза в неделю, выполнять домашние задания и не пропускать уроки.</span>.</p>

                        <img class="" src="@/assets/hometeacher/images/kuku.png">

                        <div class="knopka mrgtop110px">
                            <input id="showTimetable2" type="button" class="bluesubmit" v-model="buttonName"
                                   @click="submitIf">
                        </div>
                    </div>
                </div><!-- мобильная версия конец-->

            </div>
        </div>

        <div class="container-fluid white-bg fr-page pdtop70px">
            <div class="container align-middle">
                <div class="row pdbottom40px">
                    <div class="col-12">
                        <div class="strelki"></div>
                        <h2 class="blackh2">Как проходят занятия?</h2>
                    </div>
                </div>

                <div class="row zanatija">
                    <div class="col-12 col-sm-3 height1">
                        <div class="strela strelheight1"></div>
                        <div class="bluekrug">1</div>
                        <p><span class="strong-black">Определите уровень знаний</span> ребенка.</p>
                        <div class="gettest"><router-link to="/exams">Пройти тестирование</router-link></div>
                    </div>
                    <div class="col-12 col-sm-3 height2">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">2</div>
                        <p><a href="https://poliglotiki.com/home-teacher/schedule"><span class="strong-blue">Выберите</span></a> подходящую по возрасту и уровню подготовки <span class="strong-black">группу</span></p>
                    </div>
                    <div class="col-12 col-sm-3 height3">
                        <div class="strela strelheight3"></div>
                        <div class="bluekrug">3</div>
                        <p><span class="strong-black">Запишитесь на занятие</span> в удобное время из <a href="https://poliglotiki.com/home-teacher/schedule"><span class="strong-blue">расписания</span></a></p>
                    </div>
                    <div class="col-12 col-sm-3 height4">
                        <div class="strela strelheight4"></div>
                        <div class="bluekrug">4</div>
                        <p><span class="strong-black">Получите сообщение</span> со ссылкой на онлайн- занятие за 1 час до старта</p>
                    </div>
                </div>

                <div class="row zanatija pdtop50px">
                    <div class="col-12 col-sm-3 height5">
                        <div class="strela strelheight5"></div>
                        <div class="bluekrug">5</div>
                        <p><span class="strong-black">Проверьте оборудование</span></p>
                    </div>
                    <div class="col-12 col-sm-3 height6">
                        <div class="strela strelheight6"></div>
                        <div class="bluekrug">6</div>
                        <p><span class="strong-black">Ребенок участвует</span><br> в онлайн-уроке</p>
                    </div>
                    <div class="col-12 col-sm-6 height7">
                        <div class="strela strelheight7"></div>
                        <div class="bluekrug">7</div>
                        <p><span class="strong-black">Обратная связь</span><br> от педагога по запросу</p>
                    </div>
                </div>

                <div class="row zanatija pdtop50px">
                    <div class="col-12 col-sm-3 height8">
                        <div class="strela strelheight8"></div>
                        <div class="bluekrug">8</div>
                        <p><span class="strong-black">Промежуточные и итоговые проверки</span> для контроля усвоения материала</p>
                    </div>
                    <div class="col-12 col-sm-3">

                        <div class="bluekrug">9</div>
                        <p>По окончании курса ребенок <span class="strong-black">получает сертификат</span></p>
                    </div>
                    <div class="col-12 col-sm-6">
                        <img class="raduga" src="@/assets/hometeacher/images/raduga-birds.png">
                    </div>
                </div>
            </div>
        </div>
      <!--
      <div class="container-fluid green-grad">
        <div class="container align-middle">
          <div class="row white-kapla-left nagreen"></div>
          <div class="row">
            <div class="col-12 col-sm-8">
              <h2>Хотите сделать занятия<br> ещё эффективнее?<br>
                <span class="comboformat desktop">Выбирайте инновационный Combo-формат!</span>
                <div class="comboformat mobile">Выбирайте инновационный Combo-формат!</div></h2>

              <p style="padding-left: 10px;">Покупая абонемент, вы получаете:</p>

              <ul style="margin-top: 0px;">
                <li>занятия в записи HomeTeacher и безлимитные групповые онлайн-занятия с педагогами*.</li>
                <li>Максимальное количество знаний по оптимальной цене!</li>
              </ul>
              <span style="color: #000;">*Действительно не для всех направлений.</span>
            </div>
            <div class="col-12 col-sm-4" style="text-align: center;">
              <img src="@/assets/hometeacher/images/left-strelka.png">
              <div class="knpk-yellow">
                <a href="/home-teacher/try-free">Начать</a>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <div class="container-fluid white-bg fr-page pdtop70px">
        <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <img src="@/assets/hometeacher/images/poliglotk.jpg" class="poliglotk">
                        <h2 class="redh2">Полиглотики &ndash; международная сеть детских языковых центров</h2>
                        <div class="star1"></div>
                        <p class="px18" style="line-height: 1.3 !important;"><span class="strong-green-super">14 лет</span> опыта работы в сфере дошкольного и младшего школьного образования</p>
                        <div class="star2"></div>
                        <p class="px18" style="line-height: 1.3 !important;">Обучение ориентировано на детей <span class="strong-green">от 1 года до 12 лет</span></p>
                        <div class="star3"></div>
                        <p class="px18" style="line-height: 1.3 !important;"><span class="strong-green-super">150</span> филиалов в <span class="strong-green-super">117</span> городах России и <span class="strong-green-super">5</span> странах</p>
                        <div class="star4"></div>
                        <p class="px18" style="line-height: 1.3 !important;">Более <span class="strong-green-super">25 тысяч</span> учеников ежегодно обучаются в сети</p>
                        <div class="star5"></div>
                        <p class="px18" style="line-height: 1.3 !important;">Штат педагогов &ndash; <span class="strong-green">1,5 тысячи</span> сертифицированных специалистов</p>
                        <img src="@/assets/hometeacher/images/poliglotk2.jpg" class="poliglotk mobile-vers">
                        <p class="px18">В основе онлайн-уроков &ndash; методические материалы сети «Полиглотики», используемые в процессе офлайн-занятий.</p>

                        <p class="px18"><span class="strong-black">Более 80 авторских программ, не имеющих аналогов на мировом рынке</span>, каждая из которых прошла добровольную сертификацию на соответствие методическим, педагогическим, эргономическим требованиям и <span class="strong-black">доказала свою эффективность</span> в рамках работы языковых центров «Полиглотики».</p>

                        <div class="knopka mrgtop40px">
                        <input id="showTimetable2" type="button" class="bluesubmit desktop-vers" v-model="buttonName"
                               @click="submitIf">
                         </div>
                    </div>
                </div>

                <div class="row fr-hist-caption mb-6 px-lg-0 px-3">
                    <div class="col-12">
                        Новости образовательной платформы
                        <a href="https://www.poliglotiki.ru/novosti-poliglotikov-online" class="fr-otzyvy-all-link" target="_blank">Все новости платформы «Полиглотики»</a>
                    </div>
                </div>


                <News
                        :news-category-id="177"
                        :page="0"
                        :per-page="5"
                />

                <div class="row"  style="margin-bottom:50px;margin-top: -35px;">
                    <div class="col-12">
                        <a href="https://www.poliglotiki.ru/novosti-poliglotikov-online" class="fr-otzyvy-all-link" target="_blank">Читать все новости образовательной платформы «Полиглотики» &rarr; </a>
                    </div>
                </div>

              <div class="row">
                <div class="col-12">
                  <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                          src="https://www.poliglotiki.ru/embed/42MC62cDy00" frameborder="0"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen></iframe>

                </div>
              </div>
          <!--
                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter"></div>
                    </div>
                </div>
             -->
            </div>
        </div>

        <div class="container-fluid blue-wave-top"></div>
        <div class="container-fluid blueback" id="feedback">
            <div class="container align-middle">

                <div class="row" v-if="error">
                    <div class="col-12">
                        <base-alert type="danger">{{error}}</base-alert>
                    </div>
                </div>

                <div class="row" v-if="entryCreated">
                    <div class="col-12">
                        <base-alert type="success" dismissible>
                            Заявка успешно отправлена! Мы свяжемся с Вами при первой возможности.
                        </base-alert>
                    </div>
                </div>


                <div v-if="!entryCreated" class="row about-center">
                    <div class="col-sm">
                        <h2 class="blackh2">Формат онлайн-обучения кажется новым и непонятным?</h2>
                        <h2 class="blueh2" style="margin-top:20px;">Не стоит бояться!</h2>
                        <p class="px18">Платформа интуитивно понятна и проста. В случае возникновения любых вопросов или
                            сложностей, можно получить индивидуальную консультацию.</p>
                        <h3 class="redh3">«OnlineTeacher» - ваш домашний педагог! Присоединяйтесь к занятиям прямо
                            сейчас.</h3>

                    </div>
                </div>

                <div v-if="!entryCreated" class="row about-center" style="margin-top: 30px;" ref="entry">
                    <div class="col-sm-4 entrys">
                        <base-input v-model="name"
                                    :error="fieldError('name')"
                                    size="30" maxlength="255" placeholder="Ваше имя*" class="entry2 name"
                                    type="text" required/>
                    </div>
                    <div class="col-sm-4 entrys">
                        <base-input v-model="email"
                                    :error="fieldError('email')"
                                    size="30" maxlength="255" placeholder="E-mail*" class="entry2 email"
                                    type="text" required/>
                    </div>
                    <div class="col-sm-4 entrys-l">
                        <base-input v-model="phone"
                                    :error="fieldError('phone')"
                                    size="30" maxlength="255" placeholder="Телефон" class="entry2"
                                    type="text" required/>
                    </div>
                </div>
                <div v-if="!entryCreated" class="row">
                    <div class="col-sm">
                        <div class="knopka" style="margin-top: 10px;">
                            <input type="button" class="bluesubmit wdth80" value="Записаться на курс" @click="submit"
                                   :disabled="loading">
                        </div>
                    </div>
                </div>
            <!--
                <div class="row onlineteacher-choose onlineteacher-choose-bottom">
                    <div class="col-12 col-lg-3">
                        <div class="choose-course" style="margin-bottom: 35px;">
                            <select name="lang" v-model="langId">
                                <option value="">Выберите язык</option>
                                <option value="1">Английский язык</option>
                                <option value="2">Испанский язык</option>
                                <option value="3">Немецкий язык</option>
                                <option value="4">Французкий язык</option>
                                <option value="5">Китайский язык</option>
                                <option value="6">Русский язык</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3">
                        <div class="choose-age" style="margin-bottom: 35px;">
                            <select name="age" v-model="ageId">
                                <option value="">{{ $t('Age') }}</option>
                                <option value="1">дошкольник</option>
                                <option value="2">школьник 1-4 классы</option>
                                <option value="3">родитель</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3">
                        <div class="ind-grup">
                            <div class="form_toggle">
                                <div class="form_toggle-item item-1">
                                    <input id="fid-11" type="radio" name="radio2" value="off" checked
                                           @click="buttonName = 'Показать расписание'">
                                    <label for="fid-11">Групповое</label>
                                </div>
                                <div class="form_toggle-item item-2">
                                    <input id="fid-22" type="radio" name="radio2" value="on"
                                           @click="buttonName = 'Записаться'">
                                    <label for="fid-22">Индивидуальное</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3">

                        <div class="knopka">
                            <input id="showTimetable2" type="button" class="bluesubmit" v-model="buttonName"
                                   @click="submitIf">
                        </div>
                    </div>
                </div>
                -->

            </div>

        </div>
    </div>

</template>

<script>

    import timetablesApi from "../data/TimetablesApi";
    import News from './News'

    export default {
        name: "OnlineTeacher",
        components: {
            News,
        },
        data() {
            return {
                name: null,
                email: null,
                phone: null,
                comment: null,
                buttonName: 'Показать расписание',

                entryCreated: false,

                error: null,
                fieldsErrors: [],
                loading: false,

                langId: "",
                ageId: "",

                langFilter: null,
                ageFilter: null,

            }
        },

        metaInfo() {
            return {
                title: 'Онлайн курсы иностранных языков для детей',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: '☝☝☝☝☝ Полное ощущение присутствия, любимые преподаватели и разнообразные программы – всё это формат «OnlineTeacher»!'
                    }
                ]
            }
        },

        mounted() {

        },

        methods: {
            submit() {
                this.error = null
                this.fieldsErrors = []
                this.loading = true
                let clientId = null
                if (this.$metrika && this.$metrika.getClientID()) clientId = this.$metrika.getClientID()
                timetablesApi.createEntry(this.name, this.phone, this.email, this.comment, clientId, window.location.href)
                    .then(response => {
                        this.loading = false
                        this.entryCreated = response
                    })
                    .catch(error => {
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                        } else if (error.response.status === 401) {
                            this.error = this.$t('error_401')
                        } else {
                            this.error = this.pretty(data)
                        }
                        this.loading = false
                    })
            },

            submitIf() {
                if (this.buttonName === 'Показать расписание') {
                    if (this.langFilter && this.ageFilter) {
                        this.$router.push('/schedule/' + this.langFilter + '/' + this.ageFilter)
                    } else if (this.langFilter && !this.ageFilter) {
                        this.$router.push('/schedule/' + this.langFilter)
                    } else if (!this.langFilter && this.ageFilter) {
                        this.$router.push('/schedule/' + this.ageFilter)
                    } else {
                        this.$router.push('/schedule')
                    }
                } else {
                    this.$router.push('/individual')
                }
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    }
</script>

<style src="@/assets/hometeacher/css/main.css">
    .dla-kogo-kogda {
        background-image: url(@/assets/hometeacher/images/dla-kogo-kogda.png);
    }

</style>


<style scoped>

    .alert {
        font-size: 18px;
        font-family: "Manrope Bold";
    }

    body {
        font-family: Manrope Light;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #000000;
        text-align: left;
    }

    p {
        color: #000000;
        font-weight: 400;
        line-height: 1.5;
    }

    .OnlineTeacher {
        background-color: white !important;
    }


    .onlineteacher-choose-bottom .choose-course select,
    .onlineteacher-choose-bottom .choose-age select,
    .onlineteacher-choose-bottom .knopka input {
        width: 100% !important;
    }
    .bluesubmit{
        color:#fff;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    }
    .dla-kogo-img{ margin: 0 0 30px 10px;}
    .chto-uchim-img{ margin: 0 0 30px 10px;}
    .kak-img{ margin: 22px 0 30px -35px;}
    .kogda-img{ margin: 33px 0 12px -50px;}
    .dla-kogo p {line-height: 1 !important; padding-right: 50px;}
    .fr-page {padding-bottom: 60px !important; }
    .super-strong{
        font-family: "Manrope Bold";
        font-size:30px;
        color:#231c37;
    }
    .pdbottom100px{padding-bottom: 100px;}
    .pdbottom40px{padding-bottom: 40px;}
    .pdtop70px{padding-top: 70px;}
    .pdtop50px{padding-top: 50px;}
    .mrgtop110px{margin-top: 100px; text-align: left;}
    .mrgtop40px{margin-top: 40px;}
    .sun-img{margin-bottom: 10px;}
    .calendar-img{margin-bottom: 17px;}
    .twobirds-img{margin-bottom: 10px; margin-top: -10px;}
    .kapla-home{top:0px ;}
    .green-feedback{padding-top: 0px;}
    .sshadow {box-shadow: inset 0 4px 5px #00000038;}
    .yazik{color:#caffbb; text-align: center; font-size: 30px; font-family: "Manrope Bold"; margin-bottom: 90px; padding-top: 50px;}
    .lng {
        font-family: Manrope Bold;
        width: 120px;
        float: left;
        margin-right: 39px;
        margin-left: 15px;
    }
    .pdrght60px{padding-right: 60px!important;}
    .green-lng p{font-size:18px; color:#fff; text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3); font-family: "Manrope Bold";}
    .green-lng{text-align: center;}
    .green-lng img{margin-bottom: 3px}
    .en-img {margin-top:1px;}
    .de-img {margin-top:4px;}
    .es-img {margin-top:2px;}
    .ch-img {margin-top:12px;}
    .ru-img {margin-top:8px;}
    .preimushhestva{margin-top: -68px; max-width: 100%; margin-bottom: -40px;}
    .redh2 {z-index: 1;  position: inherit; line-height: 1.15;}
    .raketa{margin-top: -190px; margin-bottom: 70px; margin-left: 50px; max-width: 100%;}
    .onltcher{padding-top: 40px; /*text-align: left;*/ padding-bottom: 15px;}
    .onltcher h2{font-size:30px !important; padding-bottom: 15px; text-align: left;}

    .onltcher h3{
        font-size: 24px!important;
        font-family: Manrope Bold;
        color: #00b4f1;
        margin-top: -20px;
        margin-bottom: 10px; text-align: left;
    }

    .onltcher p {font-size: 18px; max-width: 500px; text-align: left;}
    .No{
        font-family: "Manrope Bold";
        color:#d7e1e5;
        text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.3);
        font-size: 40px;
    }
    .number{
        font-family: "Manrope Bold";
        color:#ffdb00;
        text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.3);
        font-size: 60px;
    }
    .speach{margin-top: 50px; max-width: 100%}
    .strelki{background-image: url(~@/assets/hometeacher/images/strelki.png);
        width:633px; height: 67px;
        margin-top: 20px; margin-right: 60px; float: right;}
    .bluekrug{
        width: 60px;
        height: 60px;
        border: 3px solid #00b4f1;
        border-radius: 50%;
        text-align: center;
        color: #4f4d5c; background: #fff;
        padding-top: 10px;
        font-size: 24px;
        font-family: "Manrope Bold";
        margin-bottom: 20px;
        position: relative; z-index: 10;
    }
    .vidos {width:100%; height: 623px;}
    .zanatija p{font-size: 18px; max-width: 210px;    margin-bottom: 20px;}
    .zanatija a:hover{text-decoration: underline;}
    .gettest{width: 200px;
        font-size: 17px;
        border-radius: 7px;
        font-family: Manrope Bold;
        background: linear-gradient(to top, #f3bf00, #fee900);
        padding: 20px 20px;
        line-height: 1;
        box-shadow: 2px 2px 3px 0px rgb(40 40 40 / 37%);
        text-decoration: none;
        text-align: center;}
    .gettest a {color: #000; text-decoration: none !important;}
    .bluesubmit { background: linear-gradient(to top, #00a6f2, #00c7ff) !important;}
    .raduga{float: right; margin-top: -120px;}
    .strela{
        background-image: url(~@/assets/hometeacher/images/strela.png);
        width: 176px;
        height: 19px;
        margin-top: 20px;
        left: 78px;
        position: absolute;
    }
    .strelheight4, .strelheight7{display: none;}
    .poliglotk{max-width: 520px;float: right;margin-top: 30px;}
    .strong-green-super{color: #5ab947;
        font-family: Manrope Bold;
        font-size: 36px;}
    .strong-green{font-size: 24px;}
    .star1{margin-right: 20px; background: url(~@/assets/hometeacher/images/star.png) no-repeat;
            width:20px; height: 20px; float: left; margin-top: 16px; margin-bottom: 40px;}
    .star2{margin-right: 20px; background: url(~@/assets/hometeacher/images/star.png) no-repeat;
        width:20px; height: 20px; float: left; margin-top: 5px; margin-bottom: 10px;}
    .star3{margin-right: 20px; background: url(~@/assets/hometeacher/images/star.png) no-repeat;
        width:20px; height: 20px; float: left; margin-top: 14px; margin-bottom: 25px;}
    .star4{margin-right: 20px; background: url(~@/assets/hometeacher/images/star.png) no-repeat;
        width:20px; height: 20px; float: left; margin-top: 18px; margin-bottom: 10px;}
    .star5{margin-right: 20px; background: url(~@/assets/hometeacher/images/star.png) no-repeat;
        width:20px; height: 20px; float: left; margin-top: 6px; margin-bottom: 10px;}

    .about-center h2{font-size: 30px !important;}
    .name{float: right; width:350px;}
    .email{float: left; width:350px;}
    .leftpunktir{display: none;}
    .greenkrug{
        width: 40px; height: 40px;
        border: 3px solid #ffdb00;
        background: #5ab947;
        border-radius: 50%;
        text-align: center;
        color: #ffdb00;
        padding-top: 4px;
        font-size: 18px;
        font-family: "Manrope Bold";
        float: left;
        margin-left: 20px; margin-right: 18px; margin-bottom: 20px;
        position: relative; z-index: 10;
    }
    .leftpunktir-yellow{
        display: block;
        width: 3px;
        border-left: 3px dashed #ffdb00;
        position: absolute;
        margin-top: 40px;
        margin-left: 39px;
    }
    .preimush{margin-top: 30px;}
    .preimush p{font-size: 18px; text-align: left; line-height: 1.1; padding-top: 5px; position: relative; z-index: 20;}
    .preimush img{float: right; }
    .punkt{max-width: 100%; min-height: 90px;}
    .galka{position: absolute; left:43px; bottom: 277px;}
    .wdth85{width:85%}
    .comboformat{background-image: url(~@/assets/hometeacher/images/combik.png);
      padding-left: 8px;
      padding-top: 2px;
      color: #000;
      padding-bottom: 11px;
      padding-right: 8px;
      font-size: 28px;}
    .green-grad p, .green-grad ul {color: #fff;
      margin-top: 30px;     max-width: 630px;
      font-size: 20px;
      font-family: 'Manrope Bold Alt';}
    .green-grad {padding-bottom: 30px;}
    .green-grad img {margin-right: -360px;}
    .knpk-yellow{max-width: 290px;}
    .green-grad img{margin-right: -310px;}


    @media (max-width: 800px) {
        .raketa {margin-left: 0px;}
        .strela {display: none;}
        .gettest{width:100%;}
        .raduga{max-width: 100%; margin-top: -20px;}
        input{width:180px;}
        .poliglotk{display: none;}
      .vidos {height:400px;}
    }
    @media (max-width: 750px) {
      .vidos {height:290px;}
    }
    @media (max-width: 640px) {
        .lng {width: 50%; margin-right: 0; margin-left: 0}
    }

    @media (max-width: 575px) {
        input{width:290px;}
        .group4birds{margin-top: 80px;}
        .dla-kogo-img{float: right; margin: -95px 30px 0px 20px;}
        .chto-uchim-img {float: right; margin: -95px 3px 0px 20px;}
        .kak-img {float: right; margin: -70px 3px 0px 20px;}
        .kogda-img {float: right; margin: -62px 3px 0px 20px;}
        .dla-kogo p{margin-left: 0px; padding-right: 20px;}
        .leftpunktir{
            display: block;
            width:100%;
            height:120px;
            border-left: 2px dashed lightgrey;
            margin-bottom: 7px;
        }
        .pdtop70px {padding-top: 30px;}
        .super-strong{text-align: center;}
        .pdtop50px{padding-top: 0px;}
        .sun-img, .calendar-img, .twobirds-img {float: left;}
        .sun-img{margin-top: -30px;
            margin-right: 20px;
            margin-bottom: 55px;}
        .calendar-img{margin-top: -25px;
            margin-left: 15px;
            margin-right: 30px;
            margin-bottom: 66px;}
        .twobirds-img{margin-top: -28px;
            margin-left: -10px;
            margin-right: 20px;}
        .preimushhestva{margin: auto; margin-top: 40px; margin-bottom: 20px;}
        .raketa {
            margin-left: auto;
            margin-right: auto;
            width: 210px;
            margin-top: 0px;
            margin-bottom: 0px;
        }
        .pdbottom100px{padding-bottom:0px;  margin-bottom: -90px;}
        .onltcher{padding-right: 30px; padding-left: 30px;}
        .onltcher img{max-width: 110%; margin-right: -20px; margin-left: -20px;}
        .mrgtop110px{margin-top: 25px; text-align: center;}

        .strelki{background-image: url(~@/assets/hometeacher/images/strelki2.png);
            width:100%; float: none;}
        .bluekrug{margin-left: 20px; margin-right: 20px; float: left;}
        .zanatija p{max-width:100%;}
        .gettest{width: 220px;
            float: right;
            margin-right: 20px;
            margin-bottom: 20px;}
        .bluekrug{position: relative; z-index: 10; margin-bottom: 50px;}
        .strelheight4, .strelheight7 {display: block;}
        .strela{
            background: url(~@/assets/hometeacher/images/streladown.png) bottom no-repeat !important;
            display: block;
            width: 18px;
            position: absolute;
            left:56px; top:39px;    }
        .strelheight1 {height: 106px;} .height1{height:175px;}
        .strelheight2 {height: 55px;} .height2{height:123px;}
        .strelheight3 {height: 64px;} .height3{height:130px;}
        .strelheight4 {height: 55px;} .height4{height:120px;}
        .strelheight5 {height: 41px;} .height5{height:107px;} .height5 p{padding-top: 10px;}
        .strelheight6 {height: 41px;} .height6{height:107px;}
        .strelheight7 {height: 60px;} .height7{height:127px;}
        .strelheight8 {height: 69px;} .height8{height:135px;}

        .star1,.star2,.star3,.star4,.star5{margin-left: 20px; margin-bottom: 44px;}
        .redh2 {margin-left: 20px;}
        .poliglotk{float: none; margin: auto; max-width: 100%;}

        .name{float: none; margin:auto; width:80%;}
        .email{float: none; margin:auto; margin-top:30px; margin-bottom:30px; width:80%;}
        .wdth80{width:80%;}
        .blue-wave-top, .green-wave-bottom {background-size: auto;}
      .vidos {height:300px;}
      .green-grad h2 {font-size: 24px; text-align: center;}
      .comboformat {
        background: #fffe88;
        padding-top: 20px;
        margin-top: 20px;
        padding-left: 10px;
        margin-left: -10px;
        padding-right: 10px;
      }
      .knpk-yellow{margin: 30px auto;}
      .green-grad img {display: none;}
    }
    @media (max-width: 540px) {
      .vidos {height:295px;}
    }
      @media (max-width: 480px) {
        .vidos {height:260px;}
      }
      @media (max-width: 420px) {
        .vidos {height:230px;}
      }
      @media (max-width: 380px) {
        .vidos {height:210px;}
    }
    @media (max-width: 380px) {
    }

    .fr-hist-caption h2, .fr-hist-caption > div {
        font-size: 30px;
        padding-top: 45px;
        line-height: 36px;
        margin: 0;
    }

    .fr-otzyvy-all-link {
        float: right;
        font-size: 14px;
        color: #4f4d5c;
        text-decoration: underline;
    }

    @media (max-width: 320px) {
      .vidos {height:181px;}
    }

</style>
